import styled from 'styled-components';

export const ErrorSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

export const ErrorSectionTextBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  justify-content: center;
`;

export const Title = styled.p`
  font-weight: 700;
  font-size: 24px;
  line-height: 1;
`;

export const SubText = styled.p`
  font-weight: 400;
  font-size: 13px;
  line-height: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
`;

export const Status = styled.span`
  font-size: 5rem;
  font-weight: 800;
  line-height: 125%;
  letter-spacing: -0.06em;
  color: #e5e5e5;
`;
